import ServerResponseParser from "./ServerResponseParser.js";


if('serviceWorker' in navigator) {
	navigator.serviceWorker.addEventListener('message', event => {
		console.log('got a message!', event.data);
		if(event.data.serverResponse) {
			for(let key in event.data.serverResponse) {
				if(!event.data.serverResponse.hasOwnProperty(key)) {
					continue;
				}
				const currentData = event.data.serverResponse[key];
				console.log('at key', key, currentData);
				switch(key) {
					case 'transaction': {
						ServerResponseParser.transaction(currentData);
					}
				}
			}
		}
	});
}